import Sentry from './common/config/config.sentry.js'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'

// Zustand no necesita Provider como Redux
// Los stores se importan directamente donde se necesitan
// La autenticación usa Zustand: import useAuthStore from "./common/store/useAuthStore";
// Ejemplo de uso: const { isAuthenticated, user, loginWithUUID } = useAuthStore();

import { ClarityProvider } from '@artprov/design-system'

const rootElement = document.getElementById('root')

if (!rootElement) {
  throw new Error('No se encontró el elemento root')
}

/**
 * Estructura de la aplicación:
 * - ClarityProvider: Maneja análisis y monitoreo con Microsoft Clarity y Sentry
 * - useAuthStore: Store de Zustand para autenticación (no requiere Provider)
 *
 * La sesión se restaura automáticamente al cargar el módulo useAuthStore
 */
ReactDOM.createRoot(rootElement).render(
  <ClarityProvider projectId={import.meta.env.VITE_CLARITY_ID} sentry={Sentry}>
    <App />
  </ClarityProvider>
)
